// extracted by mini-css-extract-plugin
module.exports = {"star":"rating_star__FhCyL"};